module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_aceproject_m.cdec7d62e5b75a1e3570c10b3ab97ff2.png";